<template>
    <div class="text-center mr-3">
        <div class="judge-selections">
            <span id="orders-selected" v-text="num_judge_selections"></span>/<span id="orders-selections-max" v-text="max_selections"></span>
        </div>
        <div class="judge-selection-text">
            Selections
        </div>
    </div>
</template>

<script>
export default {
    name: "JudgingSelections",
    props: ['num_judge_selections', 'max_selections']
}
</script>
